import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import {
    TIMELINE_TRIPS,
    TIMELINE_PLAN,
    LOGIN, EDIT_TIMELINE_TRIP,
} from "../../constants/ROUTER_PATH_TITLE";

import TimelineTripList from "../../components/TimelineTripList/TimelineTripList";

import useTimelineTrip from "../../hooks/useTimelineTrip";
import AppNav from "../../App/AppNav/AppNav";
import useTranslate from "../../hooks/useTranslate";
import TripAppMenu from "../../App/AppNav/TripMenu/TripAppMenu";
import { SvgIcons } from "@tripian/react";
import { useGuestUserForSimplyCaribbean } from "../../hooks/useGuestUserForSimplyCaribbean";
import { api } from "@tripian/core";
import { useDispatch } from "react-redux";
import { saveNotification } from "../../redux/action/trip";
import Model from "@tripian/model";

const TimelineTripsPage = () => {
  const { loadingTimelineTrips, timelineTrips, timelineTripsFetch, timelineTripRemoveLocal } = useTimelineTrip();
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const isGuestForSimplyCaribbean = useGuestUserForSimplyCaribbean();

  const navigate = useNavigate();
  document.title = TIMELINE_TRIPS.TITLE(t("trips.myTrips.title"));

  useEffect(() => {
    if (!timelineTrips) {
      timelineTripsFetch();
    } else if (isGuestForSimplyCaribbean) {
      navigate(LOGIN.PATH, { replace: true });
    }
  }, [
    isGuestForSimplyCaribbean,
    navigate,
    timelineTrips,
    timelineTripsFetch,
  ]);

  const cardClicked = (tripHash: string) => {
    navigate(`${TIMELINE_PLAN.PATH}/${tripHash}/0`);
  };

    const cardEditClicked = (tripHash: string) => {
        navigate(`${EDIT_TIMELINE_TRIP.PATH}/${tripHash}`);
    };

  const cardDeleteClicked = async (tripHash: string): Promise<boolean> => {
    try {
      // Optimistically remove from list immediately for responsive UI
      timelineTripRemoveLocal(tripHash);

      await api.tripDelete(tripHash);
      // Clean up localStorage deleted slots for this trip
      const keysToRemove: string[] = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && (key.startsWith(`timeline_deleted_slots_seg_${tripHash}`) || key.startsWith(`timeline_deleted_slots_${tripHash}_`))) {
          keysToRemove.push(key);
        }
      }
      keysToRemove.forEach(k => localStorage.removeItem(k));
      // Refresh the list after delete to sync with backend
      await timelineTripsFetch();
      return true;
    } catch (error) {
      dispatch(
        saveNotification(
          Model.NOTIFICATION_TYPE.ERROR,
          "timelineTripDelete",
          ""
        )
      );
      // Refetch to restore list on error
      timelineTripsFetch();
      return false;
    }
  };

  const handleCreateTripNavigation = () => {
    // TODO: Add timeline trip creation flow
    // For now, redirect to regular trip creation
    // navigate(CREATE_TIMELINE_TRIP.PATH);
    console.log("Create timeline trip not implemented yet");
  };

  return (
    <div
      className="background-full"
      style={
        window.tconfig.IMAGE_PATHS.APP_BACKGROUND_IMG_URL
          ? {
              background: `url(${window.tconfig.IMAGE_PATHS.APP_BACKGROUND_IMG_URL})`,
            }
          : {}
      }
    >
      <AppNav
        header={TIMELINE_TRIPS.HEADER?.(t("trips.myTrips.title")) || "Timeline Trips"}
        tripAppMenu={
          <TripAppMenu
            isInTripPlan={false}
            onClickAddTrip={handleCreateTripNavigation}
            t={t}
          />
        }
      />
      <div className="flex w-full justify-between items-center mt-10 px-6 md:hidden">
        <div className="font-semibold text-2xl">
          {TIMELINE_TRIPS.HEADER?.(t("trips.myTrips.title")) || "Timeline Trips"}
        </div>
        <div
          className="w-10 h-10 bg-primary-color flex justify-center items-center rounded-full cursor-pointer"
          onClick={handleCreateTripNavigation}
        >
          <SvgIcons.Add fill="#fff" />
        </div>
      </div>
      <div className="container mt10">
        <div className="row center">
          <TimelineTripList
            timelineTrips={timelineTrips || []}
            loadingTimelineTrips={loadingTimelineTrips}
            cardClicked={cardClicked}
            cardEditClicked={cardEditClicked}
            cardDeleteClicked={(hash: string) =>
              cardDeleteClicked(hash).then(() => true)
            }
            tripCreateClicked={handleCreateTripNavigation}
          />
        </div>
      </div>
    </div>
  );
};

export default TimelineTripsPage;
